import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { createWebTransport, FamiliarProvider } from '@diwata/hearth'
import { initColorMode } from '@diwata/ironvale'
import App from './App'
import { UnauthorizedError } from '@/api/daemon'
import { useUI } from '@/store/ui'
import './components/layout.css'

document.documentElement.setAttribute('data-theme', 'daemon')
initColorMode()

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 30_000 } } })

// Global 401 handler — redirect to Gate login with ?next= so we return after auth
queryClient.getQueryCache().subscribe((event) => {
  if (event.type === 'updated' && event.query.state.error instanceof UnauthorizedError) {
    const { gateUrl } = useUI.getState()
    const next = encodeURIComponent(window.location.href)
    window.location.href = `${gateUrl}/login?next=${next}`
  }
})

// Hearth web transport — the shared DAEMON client. 401 → Gate login (same as the query handler above).
const transport = createWebTransport({
  baseUrl: useUI.getState().daemonUrl,
  onUnauthorized: () => {
    const { gateUrl } = useUI.getState()
    const next = encodeURIComponent(window.location.href)
    window.location.href = `${gateUrl}/login?next=${next}`
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <FamiliarProvider transport={transport}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </FamiliarProvider>
    </QueryClientProvider>
  </StrictMode>
)
